export default {
    packages: {
        heading: 'Packages',
        description: 'You currently have no current subscription, but<br> consider taking a look at our offers <a href="/membres" class="btn-link">member<a/>'
    },
    infolettres: 'Newsletters',
    infolettresListQc: [
        {
            value: 1,
            title: 'I would like to receive news from Boires.ca',
            description: 'Stay informed of new arrivals in outlets and on the SAQ\'s online store.'
        },
        {
            value: 2,
            title: 'Receive news about products available at SAQ',
            description: 'Inform yourself before everyone else about new arrivals in Private Import. First ordered, first served!'
        },
        {
            value: 3,
            title: 'Receive news of products available for private import',
            description: 'Learn about the amazing humans who make the wines you love.'
        },
        {
            value: 4,
            title: 'Receive news of products available in store',
            description: ''
        },
        {
            value: 5,
            title: 'Receive news about upcoming events',
            description: ''
        },
    ],
    infolettresListOn: [
        {
            value: 1,
            title: 'I would like to receive news from Boires.ca',
            description: 'Stay informed of new arrivals in outlets and on the LCBO\'s online store.'
        },
        {
            value: 2,
            title: 'Receive news about products available at LCBO',
            description: 'Inform yourself before everyone else about new arrivals in Private Import. First ordered, first served!'
        },
        {
            value: 3,
            title: 'Receive news of products available for private import',
            description: 'Learn about the amazing humans who make the wines you love.'
        },
        {
            value: 4,
            title: 'Receive news of products available in store',
            description: ''
        },
        {
            value: 5,
            title: 'Receive news about upcoming events',
            description: ''
        },
    ],
    formRequiredMsg: {
        firstName: 'Your first name is required',
        lastName: 'Your name is required',
        email: 'Your email is required',
    }
};
